import Input from "components/common/Input";
import SearchIcon from "components/icons/SearchIcon";
import Button from "components/common/Button";
import Colors from "assets/Colors";
import Selector from "components/common/Selector";

import { useTranslation } from "react-i18next";
import s from "../../../styles/TopMenu.styles";

function TopMenu({
  selectedFilter,
  changeSelectedFilter,
  changeSearchValue,
  addItem,
  loading,
}) {
  const { t } = useTranslation();
  return (
    <s.Container
      style={{
        display: "block",
      }}
    >
      <s.Title>{t("components.InventoryItems.TopMenu.searchItems")}</s.Title>
      <s.BottomContainer
        style={{
          marginBottom: "10px",
        }}
      >
        <Input
          disabled={loading}
          placeholder={t("components.InventoryItems.TopMenu.search")}
          style={{
            marginBottom: "7px",
            maxWidth: "365px",
          }}
          prefix={<SearchIcon />}
          onChange={(e) => changeSearchValue(e.target.value)}
        />
        <s.BottomRightItemsContainer>
          <Selector
            disabled={loading}
            options={[
              {
                value: "all",
                name: t("components.InventoryItems.TopMenu.all"),
              },
              {
                value: "lowStock",
                name: t("components.InventoryItems.TopMenu.lowStock"),
              },
              {
                value: "mostSold",
                name: t("components.InventoryItems.TopMenu.mostSold"),
              },
            ]}
            style={{ width: 147, marginRight: 13, marginBottom: "7px" }}
            onChange={(value) => changeSelectedFilter(value)}
            value={selectedFilter}
          />

          <Button
            disabled={loading}
            type="primary"
            style={{
              background: Colors.primary,
              color: Colors.text_on_secondary,
              width: "none",
              fontWeight: "500",
              border: "none",
              height: "40px",
              marginBottom: "7px",
            }}
            onClick={() => addItem()}
          >
            {t("components.InventoryItems.TopMenu.addArticle")}
          </Button>
        </s.BottomRightItemsContainer>
      </s.BottomContainer>
    </s.Container>
  );
}

export default TopMenu;
